<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">
          {{ isEditMode ? 'Edit Jurisdiction' : 'New Jurisdiction' }}
        </h4>
        <div class="text-muted small">
          Configure country or fallback jurisdiction settings
        </div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" (click)="cancel()">
        Back
      </button>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0">
      <div class="card-body">

        <div
          *ngIf="hasExistingGlobalFallback && !isGlobalFallback?.value && !isEditMode"
          class="alert alert-info">
          A global fallback jurisdiction already exists. You can still create country jurisdictions,
          but you cannot create another global fallback.
        </div>

        <div
          *ngIf="isGlobalFallback?.value && hasAnotherGlobalFallback()"
          class="alert alert-warning">
          A different global fallback jurisdiction already exists. Only one global fallback is allowed.
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Country</label>
            <select class="form-select" formControlName="countryId">
              <option value="">Select country</option>
              <option *ngFor="let item of countries" [value]="item.id">
                {{ item.name }} ({{ item.code || item.countryCode }})
              </option>
            </select>

            <div class="small text-danger mt-1" *ngIf="countryId?.touched && !isGlobalFallback?.value && !countryId?.value">
              Country is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Code</label>
            <input
              class="form-control"
              formControlName="code"
              placeholder="NG, CA, GLOBAL"
              readonly />

            <div class="small text-danger mt-1" *ngIf="code?.touched && code?.invalid">
              Jurisdiction code is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Name</label>
            <input
              class="form-control"
              formControlName="name"
              placeholder="Nigeria, Canada, GLOBAL"
              readonly />

            <div class="small text-danger mt-1" *ngIf="name?.touched && name?.invalid">
              Jurisdiction name is required.
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Regulatory Zone</label>
            <input
              class="form-control"
              formControlName="regulatoryZone"
              placeholder="West Africa, North America" />
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Active</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isActive" />
              <label class="form-check-label">Enabled</label>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Global Fallback</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isGlobalFallback" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Jurisdiction' : 'Create Jurisdiction' }}
          </button>

          <button class="btn btn-outline-secondary" type="button" (click)="cancel()">
            Cancel
          </button>
        </div>

      </div>
    </form>

    <app-footer></app-footer>
  </main>
</div>